import VideocoachPage from './VideocoachPage';
export default VideocoachPage;